export const defaultEntity = 'tenants';
export const entities = ['tenants'];
export const labels = {
    tenants: 'Tenants',
};